/**
 * The account the browser bills — read from the ACTIVE WORKSPACE the chat mount publishes
 * (`activeWorkspace.ts`: the same publish that binds a new thread to its organization, set
 * from the migration gate's resolved account, the id the Prest0n session itself debits).
 *
 * Why nothing else (2026-09-07 finding): the earlier derivation — the localStorage
 * `user_accounts` list, then the URL's first path segment — never named the actor's
 * account. That storage key is the email-subscription / admin-table list (a GENERATED id, or
 * somebody else's), and the path segment is a ROUTE NAME: a tab on /desktop declared the
 * account "desktop", anthropicProxy forwarded it as the billing account (#1642), and the
 * fleet proxy filed the spend under a pseudo-account with no error line. From 2026-09-06
 * 01:26 UTC every browser-lane call from /desktop, /wallet, /settings … was mis-filed that
 * way; at "/" nothing was sent and the recorder logged UNRESOLVED ACCOUNT instead.
 *
 * Contract: `knownAccountHint()` returns the resolved workspace account id, or '' when the
 * browser does not know one yet (a guest, or the seconds before the migration gate resolves).
 * Callers stamp `X-Account-Id` only when it is non-empty — an absent header reads as
 * 'unknown' on every server door and the recorder stays loud; a wrong header is a silent
 * mis-file. Never derive an account from storage or the URL here.
 */
import { getActiveWorkspaceAccount } from './activeWorkspace';

/** The account the browser acts for, or '' when none is known yet. */
export function knownAccountHint(): string {
  try {
    return getActiveWorkspaceAccount() ?? '';
  } catch {
    return '';
  }
}
